import PopularProcessGoals from './PopularProcessGoals';

export default PopularProcessGoals;
